<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='@@customerOverviewComponent.heading.tixxSelectRequests' class="esf-action-heading__text">Tixx-Select Requests</span>
    </h1>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="currentSubmissions"
                         [actionButtons]="actionButtons"
                         (rowButtonClickEvent)="actionButtonClicked($event)"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="setNewSubmissionList($event)"
                         (rowClickEvent)="viewSubmissionDetails($event)"

                         [emptyStateText]="tablesTranslations.i18nNoSubmissions"
                         [emptyStateIcon]="'#esf-icon-clover-leaf-48'">

    </app-paginated-table>

  </div>
</main>
